import { formatDate } from '../utils/formatters'
import queryString from 'query-string'
import { serviceHelper } from '../utils/serviceHelper'

export const getDailyAttendanceDetailed = async (professionalId, date) => {
  const schedulerApi = getAxiosCreate()
  const query = {
    start: formatDate({ date, format: 'DD-MM-YYYY' }),
    end: formatDate({ date, format: 'DD-MM-YYYY' })
  }
  const { data } = await schedulerApi.get(`/report/professional/${professionalId}/attendances-history/detailed?${queryString.stringify(query,
    { arrayFormat: 'bracket' })}`, { headers: { 'x-professional-user-id': professionalId } })
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_SCHEDULER_URL}`)
}
